import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "none",
      d: "M17.5 3.875a4.125 4.125 0 0 1 2.697 7.246c.278.749.428 1.548.428 2.379 0 2.39-1.243 4.519-3.18 5.914q-.425.306-.89.562l-.037.02A9.44 9.44 0 0 1 12 21.125a9.44 9.44 0 0 1-4.518-1.129 9 9 0 0 1-.882-.55l-.045-.032c-1.937-1.395-3.18-3.524-3.18-5.914 0-.83.15-1.63.428-2.379a4.125 4.125 0 1 1 6.335-5.068A10 10 0 0 1 12 5.875q.961.001 1.862.178A4.12 4.12 0 0 1 17.5 3.875m-3.977 12.522c-.11.204-.3.374-.533.497-.276.146-.62.231-.99.231s-.714-.085-.99-.23a1.26 1.26 0 0 1-.532-.498 4.4 4.4 0 0 0-2.523 2.433A8.17 8.17 0 0 0 12 19.875a8.17 8.17 0 0 0 4.045-1.045 4.38 4.38 0 0 0-2.523-2.433M12 7.125c-4.116 0-7.375 2.9-7.375 6.375 0 1.799.87 3.44 2.282 4.608a5.626 5.626 0 0 1 10.186 0c1.412-1.168 2.282-2.81 2.282-4.608 0-3.475-3.26-6.375-7.375-6.375m-5.5-2a2.875 2.875 0 0 0-2.127 4.81c.968-1.614 2.57-2.882 4.509-3.547A2.88 2.88 0 0 0 6.5 5.125m11 0c-.975 0-1.858.49-2.382 1.263 1.94.665 3.541 1.933 4.509 3.547a2.875 2.875 0 0 0-2.127-4.81"
    }, null, -1)
  ]))]))
}
export default { render: render }